(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('LoginController', LoginController);

    LoginController.$inject = [
        '$rootScope',
        '$state',
        '$timeout',
        'Auth',
        '$uibModalInstance',
        'LoginService',
        'ContactUsService',
        'DocumentationUtils',
        '$sessionStorage',
        'UserAccessWindow'
    ];

    function LoginController($rootScope, $state, $timeout, Auth, $uibModalInstance, LoginService, ContactUsService, DocumentationUtils, $sessionStorage, UserAccessWindow) {
        var vm = this;
        vm.authenticationError = false;
        // SUP-12293: the account's access has ended. Only ever set after the server accepted the password (or a token),
        // so it tells nothing to someone who cannot sign in as the account.
        vm.accessExpired = false;
        vm.accessExpiredDay = null;
        showAccessExpired($sessionStorage.accessExpired);

        function showAccessExpired(notice) {
            if (!notice) {
                return;
            }
            delete $sessionStorage.accessExpired;
            vm.accessExpired = true;
            vm.authenticationError = false;
            vm.accessExpiredDay = UserAccessWindow.lastDay(notice.accessValidUntil);
        }
        vm.credentials = {};
        vm.username = null;
        vm.password = null;
        vm.rememberMe = true;
        vm.isSaving = false;
        vm.cancel = cancel;
        vm.login = login;
        vm.contactUs = contactUs;
        vm.downloadManual = downloadManual;
        vm.requestResetPassword = requestResetPassword;

        $timeout(function() {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            vm.isSaving = true;
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            })
                .then(function() {
                    vm.isSaving = false;
                    vm.authenticationError = false;
                    $uibModalInstance.close();
                    if ($state.current.name === 'activate' || $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                        $state.go(Auth.homeState());
                    }

                    $rootScope.$broadcast('authenticationSuccess');

                    if (Auth.getPreviousState()) {
                        Auth.goToPreviousState();
                    }
                })
                .catch(function(err) {
                    vm.isSaving = false;
                    if (err && err.data && err.data.title === 'accessExpired') {
                        showAccessExpired({ accessValidUntil: err.data.accessValidUntil });
                    } else {
                        vm.accessExpired = false;
                        vm.authenticationError = true;
                    }
                });
        }

        function contactUs() {
            $uibModalInstance.dismiss('cancel');
            ContactUsService.open();
        }

        function downloadManual() {
            DocumentationUtils.openUserManual();
        }

        function requestResetPassword() {
            LoginService.reset();
        }
    }
})();
